import emitter from "../../Utils/events/eventBus";

// Section ids for "Grow your community", plus one event to bring a section into
// view — on mobile the sections are accordions, so something that points at a
// section (a task, a step link) must open it before scrolling to it.
export const GROW_COMMUNITY_PATH = "/grow-community";
export const TASKS_ID = "weekly-tasks";
export const SHARE_GRID_ID = "share-grid";
export const REPLY_HELPER_ID = "reply-helper";

export const REVEAL_EVENT = "grow-community-reveal";
export const revealSection = (id) => emitter.emit(REVEAL_EVENT, id);
